import {
  Component,
  HostBinding,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'backoffice-create-merge-report-button',
  templateUrl: './create-merge-report-button.component.html',
  styleUrls: ['./create-merge-report-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CreateMergeReportButtonComponent {
  @Input() isGeneratingMergeReport!: boolean;
  @HostBinding('class.disabled')
  @Input()
  disabled!: boolean;
}
